import * as actions from "./actions";
import * as types from "./mutation-types";

const state = {
  zonesList: [],
  zonesError: "",
  zonesLoading: false,
};

const getters = {
  zonesLoading: state => state.zonesLoading,
  zonesError: state => state.zonesError,
  zonesList: state => state.zonesList,
};

const mutations = {
  [types.GET_ZONES_REQUEST](state) {
    state.zonesLoading = true;
    state.zonesError = "";
    state.zonesList = [];
  },
  [types.GET_ZONES_SUCCESS](state, zonesList) {
    state.zonesLoading = false;
    state.zonesError = "";
    state.zonesList = zonesList;
  },
  [types.GET_ZONES_FAILURE](state, zonesError) {
    state.zonesLoading = false;
    state.zonesError = zonesError;
    state.zonesList = [];
  },
};

export default {
  state,
  actions,
  getters,
  mutations
};
